import React, {useEffect, useState} from 'react';
import { ValidationPageContainer, ValidationSlide, CheckboxStyled, ButtonSlide } from './style';
import {useTranslation} from 'react-i18next';
import Slider, { SliderCommands } from '../../components/Slider';
import useCountDown from '../../hooks/useCountDown';
import { Link } from 'react-router-dom';

interface PreSOPProps {
  startVerification: () => void;
  businessName?: string;
  businessColor?: string;
  temp?: string;
  expiresAt?: string;
  createdAt?: string;
  htmlSnippet?: string;
}

const CountDown = ({ aDate, onFinalCountDown, daysLinkDuration}: {aDate: string, onFinalCountDown: () => void, daysLinkDuration: number}) => {
  const { t } = useTranslation();
  const { countDown, finalCountDown } = useCountDown(aDate);

  useEffect(()=>{
    if (finalCountDown) {
      onFinalCountDown();
    }
  },[finalCountDown]);
  return <>
    {daysLinkDuration > 30 && <h2> {t('verifications.warning.months', { count: countDown.months })}</h2> }
    {daysLinkDuration > 1 && <h2> {t('verifications.warning.days', { count: countDown.days })}</h2> }
    <h2>{("0" + countDown.hours).slice(-2)}:{("0" + countDown.minutes).slice(-2)}:{("0" + countDown.seconds).slice(-2)}</h2>
  </>
}

const LASTINDEX = 3;

export const PreSOP = ({ startVerification, businessColor, expiresAt, createdAt, htmlSnippet }: PreSOPProps) => {
  const { t } = useTranslation();
  const sliderRef = React.useRef<SliderCommands>();
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = () => {
    setIsChecked(!isChecked);
  };

  const onButtonDownloadClick = async (e: any, path: string, filename: string) => {
    e.preventDefault();
    const response = await fetch(path);
    const blob = await response.blob();
    const fileURL = window.URL.createObjectURL(blob);
    const alink = document.createElement('a');
    alink.href = fileURL;
    alink.download = filename;
    alink.click();
  }


  const handlePrev = () => {
    sliderRef?.current?.previous();
  }
  const handleNext = () => {
    sliderRef?.current?.next();
  }

  const handleSkip = () => {
    sliderRef?.current?.goTo(LASTINDEX +1);
  }

  const handleFinalCountdown = () => {
    window.location.href = window.location.href;
  }

  function createHtmlSnippet() {
    return {__html: htmlSnippet?htmlSnippet:''};
  }

  const daysLinkDuration = (new Date(expiresAt || '').getTime() - new Date(createdAt || '').getTime()) / (1000 * 60 * 60 * 24);

  return (
    <ValidationPageContainer
      color={
        businessColor?.toLocaleLowerCase() !== '#ffffff'
          ? businessColor || '#666'
          : '#666'
      }
      style={ currentIndex < 4 ? { paddingTop: 15 }: {} }
    >
      <Slider
        ref={sliderRef}
        settings={{
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: (currentIndex < 3 ? true: false),
          infinite: false,
          beforeChange: (_current, next) => setCurrentIndex(next),
        }}
      >
        <ValidationSlide>
          <div className="welcome">
            <h4>{t('verifications.welcome.title')}</h4>
            <p>{t('verifications.welcome.description')}</p>
          </div>
          <div className="howTofaceContainer">

            <section>
              <img
                src="/assets/img/verification-idface-left.svg"
                alt="camera"
                className='id'
              />
              <div className='textContainer'>
                <h5>{t('verifications.id.title')}</h5>
                <p>{t('verifications.id.description')}</p>
              </div>
            </section>
            <section className='leftContent'>
              <div className='textContainer'>
                <h5>{t('verifications.lifeproof.title')}</h5>
                <p>{t('verifications.lifeproof.description')}</p>
              </div>
              <img
                src="/assets/img/verification-idface-right.svg"
                alt="camera"
                className='face'
              />
            </section>

            <section>
              <img
                src="/assets/img/verification-camera.svg"
                alt="camera"
                className='camera'
              />
              <div className='textContainer'>
                <h5>{t('verifications.camera.title')}</h5>
                <p>{t('verifications.camera.description')}</p>
              </div>
            </section>
          </div>

        </ValidationSlide>

        <ValidationSlide>
          <div className="howTofaceContainer">
            <h4>{t('verifications.howtoid.title')}</h4>
            <section>
              <img
                src="/assets/img/howto-01.svg"
                alt="camera"
                className='imgMedium'
              />
              <p >{t('verifications.howtoid.first')}</p>
            </section>
            <section>
            <p >{t('verifications.howtoid.second')}</p>
              <img
                src="/assets/img/howto-02.svg"
                alt="camera"
                className='imgMedium'
              />

            </section>
            <section>

              <img
                src="/assets/img/howto-03.svg"
                alt="camera"
                className='imgMedium'
              />
              <p >{t('verifications.howtoid.third')}</p>
            </section>
          </div>

        </ValidationSlide>
        <ValidationSlide>
          <div className="howTofaceContainer">
            <h4>{t('verifications.howtoselfie.title')}</h4>
            <section>
              <img
                src="/assets/img/howto-04.svg"
                alt="camera"
                className='img'
              />
              <p >{t('verifications.howtoselfie.first')}</p>
            </section>
            <section>
            <p >{t('verifications.howtoselfie.second')}</p>
              <img
                src="/assets/img/howto-05.svg"
                alt="camera"
                className='img'
              />

            </section>
            <section>

              <img
                src="/assets/img/howto-06.svg"
                alt="camera"
                className='imgMedium'
              />
              <p >{t('verifications.howtoselfie.third')}</p>
            </section>
          </div>

        </ValidationSlide>

        <ValidationSlide>

          <h2>{t('verifications.warning.title')}</h2>
          <p>{t('verifications.warning.description')}</p>
          <img
            src="/assets/img/verification-clock.svg"
            alt="clock"
            className="foot"
          />
          {expiresAt && <p className='expiresIn'>{t('verifications.warning.expiresIn')}</p> }
          {expiresAt && <CountDown aDate={expiresAt} onFinalCountDown={handleFinalCountdown} daysLinkDuration={daysLinkDuration}/>}
          <br />
          <div dangerouslySetInnerHTML={createHtmlSnippet()}/>

          <button onClick={() => { startVerification()}}>
            {t('verifications.warning.start')}
          </button>

        </ValidationSlide>
      </Slider>
      {currentIndex <= (LASTINDEX - 1) &&
        <div className='buttonContainer' style={currentIndex === LASTINDEX ? {zIndex: 2} : {}}>
          {currentIndex <= (LASTINDEX - 1) &&
            <>
              <div className='skip'>
                <button onClick={handleSkip}>{t('verifications.skip')}</button>
              </div>
              <div className='arrows'>
                <ButtonSlide className={`${currentIndex === 0 ? 'extreme' : ''}`} onClick={handlePrev}/>
                <ButtonSlide className={`next ${currentIndex === LASTINDEX ? 'extreme' : ''}`} onClick={handleNext}/>
              </div>
            </>
          }
        </div>
      }
    </ValidationPageContainer>
  );
};
